import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .SavedMethods {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &__title {
      color: rgba(0, 0, 0, 0.5);
    }

    &__requisites {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      &-container {
        position: relative;
      }

      &-item {
        background-color: #fff;
        border: 2px solid #e4e4e4;
        border-radius: 10px;
        padding: 12px;
        display: flex;
        gap: 16px;
        width: 220px;

        &-remove {
          position: absolute;
          top: -10px;
          right: -10px;

          width: 24px;
          height: 24px;

          border: 2px solid #e4e4e4;
          border-radius: 50%;
          background: #fff;

          display: flex;
          align-items: center;
          justify-content: center;

          cursor: pointer;
          z-index: 1;

          &:hover {
            border-color: #c8c8c8;
          }

          :global(svg) {
            width: 12px;
            height: 12px;
          }
        }

        &-icon {
          display: flex;
          align-items: center;

          img {
            width: auto;
            height: 40px;
          }
        }

        &-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          min-width: 0;

          &--title,
          &--card-number {
            width: 100%;
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &--title {
            font-size: 16px;
            font-weight: 500;
          }

          &--card-number {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }

    &__confirm-modal-actions {
      display: flex;
      justify-content: space-around;
      padding-top: 20px;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css`
    .SavedMethods {
      &__requisites {
        &-item {
          border-radius: ${border.radius};

          &:hover {
            border-color: ${rgba([colors.primary.rgb, 0.4])};
          }

          &--active {
            border-color: ${rgba([colors.primary.rgb, 0.4])};
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
